import React, { useState } from 'react'
import { Box, Tabs, Tab } from '@mui/material'
import PageHeader from '../components/ui/PageHeader'
import WhatsAppEnotifyConnection from '../components/whatsapp/WhatsAppEnotifyConnection'
import WhatsAppNotificationSettings from '../components/whatsapp/WhatsAppNotificationSettings'
import WhatsAppTemplatesTab from '../components/whatsapp/WhatsAppTemplatesTab'
import WhatsAppTestMessage from '../components/whatsapp/WhatsAppTestMessage'

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

const TabPanel: React.FC<TabPanelProps> = ({ children, index, value }) => (
  <Box role="tabpanel" hidden={value !== index} sx={{ pt: 3 }}>
    {value === index && children}
  </Box>
)

const WhatsAppConfigurationPage: React.FC = () => {
  const [tab, setTab] = useState(0)

  return (
    <Box>
      <PageHeader
        title="WhatsApp"
        subtitle="Single source of truth for the Enotify connection, notification settings, templates, and test sends"
      />

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tab} onChange={(_, v) => setTab(v)}>
          <Tab label="Enotify Connection" />
          <Tab label="Notification Settings" />
          <Tab label="Templates" />
          <Tab label="Test Messages" />
        </Tabs>
      </Box>

      <TabPanel value={tab} index={0}>
        <WhatsAppEnotifyConnection />
      </TabPanel>
      <TabPanel value={tab} index={1}>
        <WhatsAppNotificationSettings />
      </TabPanel>
      <TabPanel value={tab} index={2}>
        <WhatsAppTemplatesTab />
      </TabPanel>
      <TabPanel value={tab} index={3}>
        <WhatsAppTestMessage />
      </TabPanel>
    </Box>
  )
}

export default WhatsAppConfigurationPage
